/**
 *
 * Scheduler
 *
 */

import React, { useState, useEffect } from 'react';
import './scheduler.module.css';

function addDays(d, days) {
  var date = new Date(d.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

function addMonths(d, months) {
  var date = new Date(d.valueOf());
  date.setMonth(date.getMonth() + months);
  return date;
}

function daysInMonth(month, year) {
  return new Date(year, month + 1, 0).getDate();
}

function dayDifference(first, second) {
  // Take the difference between the dates and divide by milliseconds per day.
  // Round to nearest whole number to deal with DST.

  return Math.round((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24));
}

function getSchedulerFirstDayInView(date) {
  let day = date.getDay();
  let initialMonth = date.getMonth();
  let initialYear = date.getYear() + 1900;
  let resultMonth = date.getMonth();
  let monthDayNum = date.getDate();
  let visualEnded = false;
  while (monthDayNum > 0) {
    monthDayNum--
    day--;
    if (day < 0 && monthDayNum > 0) {
      // More days to track in the previous month
      day = 6;
    } else if (day < 0 && monthDayNum == 0) {
      // Month and visual ended on sunday
      return new Date(initialYear, resultMonth, 1);
    }
  }

  if (day > 0 && !visualEnded) {
    // More days to track in the previous month
    resultMonth--;
    if (resultMonth < 0) {
      resultMonth = 11;
      initialYear--;
    }

    monthDayNum = daysInMonth(resultMonth, date.getYear());
    while (day > 0) {
      day--;
      monthDayNum--;
    }
  }

  return new Date(initialYear, resultMonth, monthDayNum);
}

function SchedulerMonthNavigator(props) {
  const { date, motion, onIncrementMonth, onDecrementMonth } = props;
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  let style = {};
  style.animationDuration = "0.1s"
  style.animationName = "entrance-motion-" + motion;

  return (
    <div className='schedulerNav'>
      <div className='schedulerNavArrowButton left' onClick={onDecrementMonth}>
        <span className="scheduler-caret left"></span>
      </div>
      <div style={style} className='schedulerNavMonthLabel'>
        {monthNames[date.getMonth()]} {date.getYear() + 1900}
      </div>
      <div className='schedulerNavArrowButton right' onClick={onIncrementMonth}>
        <span className="scheduler-caret right"></span>
      </div>
    </div>
  )
}

function SchedulerMatrixCell(props) {
  const { dayRangesAllowed, showAvailabilityCounts, availability, showEndDateNote, date, hoverDate, selected, disabled, selectionDateRangeStart, selectionDateRangeEnd, offMonth, motion, col, index, onSelectDay, onHoverDay } = props;
  let style = {};
  style.animationDuration = "0.15s";//(0.1 + ((motion === 'left' ? props.col : (6.0 - props.col)) * 0.05)) + "s";
  style.animationName = "entrance-motion-" + motion;

  const handleSelect = () => {
    onSelectDay(date);
  }

  const handleClear = () => {
    onSelectDay(null)
  }

  const handleHoverEnter = () => {
    onHoverDay(date, true);
  }

  const handleHoverExit = () => {
    onHoverDay(date, false);
  }

  let cellSelectionElem;
  let cellSelectionBridgeElem;
  let cancelButtonElem;
  let noteElem;
  if (selected) {
    cellSelectionElem = <div className="cellSelectionElement"></div>
    if (selectionDateRangeStart) {
      if (date.getTime() < selectionDateRangeStart.getTime()) {
        cellSelectionBridgeElem = <div className='cellSelectionBridgeElement' />
      } else if (date.getTime() === selectionDateRangeStart.getTime()) {
        cancelButtonElem = <div className='cellSelectionCancel' onClick={handleClear}>
          <i style={{ marginRight: 5 }} className="fa fa-times" />Clear
        </div>
        if (selectionDateRangeEnd && selectionDateRangeEnd.getTime() !== selectionDateRangeStart.getTime()) {
          cellSelectionBridgeElem = <div className="cellSelectionStartCapElement"></div>
        }
        if (showEndDateNote) {
          noteElem = <div className='cellSelectionNote' onClick={handleClear}>
            <i style={{ marginRight: 5 }} className="fa fa-info-circle" />Select End Date
          </div>
        }
      } else if (date.getTime() > selectionDateRangeStart.getTime()) {
        cellSelectionBridgeElem = <div className='cellSelectionBridgeElement' />
      }
    }

    if (selectionDateRangeEnd) {
      if (date.getTime() === selectionDateRangeEnd.getTime() && selectionDateRangeEnd.getTime() !== selectionDateRangeStart.getTime()) {
        cellSelectionBridgeElem = <div className='cellSelectionEndCapElement' />
      }
    }
  }

  let hoverElem;
  let hoverSelectionElem;
  if (hoverDate) {
    if (hoverDate.getTime() === date.getTime() ||
      (selectionDateRangeStart && date.getTime() === selectionDateRangeStart.getTime())) {
      // Hovering over this cell
      hoverSelectionElem = <div className='schedulerMatrixCellHoverElem'></div>;
    }

    if (selectionDateRangeStart) {
      if (date.getTime() > hoverDate.getTime() && date.getTime() < selectionDateRangeStart.getTime()) {
        // Left of selection, between hover and selection
        hoverElem = <div className="cellRangeBridge"></div>
        if (selected) {
          cellSelectionBridgeElem = <div className='cellSelectionBridgeElement' />
        }
      } else if (date.getTime() == hoverDate.getTime() && date.getTime() < selectionDateRangeStart.getTime() ||
        date.getTime() < hoverDate.getTime() && date.getTime() === selectionDateRangeStart.getTime()) {
        // Left of selection, is the hover cell
        hoverElem = <div className="cellRangeStartcap"></div>
      } else if (date.getTime() < hoverDate.getTime() && date.getTime() > selectionDateRangeStart.getTime()) {
        hoverElem = <div className="cellRangeBridge"></div>
      } else if (date.getTime() == hoverDate.getTime() && date.getTime() > selectionDateRangeStart.getTime() ||
        date.getTime() > hoverDate.getTime() && date.getTime() === selectionDateRangeStart.getTime()) {
        hoverElem = <div className="cellRangeEndcap"></div>
      }
    }
  }

  let cellDisabled = disabled;
  let cellDisabledElem;
  let isToday = false;
  let todayDate = new Date();
  let todayElem;
  if (date.getYear() == todayDate.getYear() && date.getMonth() === todayDate.getMonth() && date.getDate() === todayDate.getDate()) {
    isToday = true;
    todayElem = <div className="cellTodayElem" />
  }

  let availabilityElem;
  let showCounts = showAvailabilityCounts;
  let showDeco = !showCounts;
  if (availability && availability.count != null) {
    let style = {};
    // if (disabled) {
    //   style.display = "none";
    // }
    if (selectionDateRangeStart && selectionDateRangeStart.getTime() !== date.getTime()) {
      // style.opacity = 0.0;
    }
    if (availability.count > 0) {
      style.background = "#03c03c";
      availabilityElem = <div style={style} className={`schedulerAvailabilityDeco ${showAvailabilityCounts ? "showCounts" : ""}`}>{showAvailabilityCounts ? availability.count : ""}</div>
    } else if (availability.count <= 0) {
      style.background = "#c23b22";
      availabilityElem = <div style={style} className={`schedulerAvailabilityDeco ${showAvailabilityCounts ? "showCounts" : ""}`}>{showAvailabilityCounts ? 0 : ""}</div>
    }
  }

  if (cellDisabled) {
    cellDisabledElem = <div className={`cellDisabledElem ${showDeco ? "showDeco" : ""} ${showAvailabilityCounts ? "showCounts" : ""} ${showAvailabilityCounts ? "showCounts" : ""} ${selected ? "unrendered" : ""}`}></div>
  }

  return (
    <div style={style} className={`schedulerMatrixCell ${showDeco ? "showDeco" : ""} ${showCounts ? "showCounts" : ""} ${disabled ? 'cellDisabled' : ''} ${offMonth ? 'offMonthCell' : ''} ${selected ? 'cellSelected' : ''}`}>
      {date.getDate()}
      {hoverSelectionElem}
      <div className='schedulerMatrixSelectionElem' onMouseEnter={handleHoverEnter} onMouseLeave={handleHoverExit} onClick={handleSelect}></div>
      {cellSelectionElem}
      {cellSelectionBridgeElem}
      {todayElem}
      {hoverElem}
      {availabilityElem}
      {cellDisabledElem}
      {noteElem}
      {cancelButtonElem}
    </div>
  )
}

const generateDaystamp = (date) => {
  if (!date) {
    date = new Date();
  }

  let tokens = date.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }).split("/");

  return Number(tokens[2] + tokens[0] + tokens[1]);
}

function SchedulerMatrix(props) {
  const { date,
    availability,
    showAvailabilityCounts,
    onSetViewRange,
    hoverDate,
    motion,
    selectedDates,
    blockedDates,
    minimumDate,
    selectionDateRangeStart,
    selectionDateRangeEnd,
    allowSelectTimeframes,
    timeframeInterval,
    showEndDateNote,
    timeframeStart,
    timeframeEnd,
    onEditTimeframe,
    schedulerTimeframeMatch,
    timeframeSelectorProperties,
    endTimeRequirement,
    onSelectDay,
    onHoverDay,
    dayRangesAllowed,
    allowSingleDay,
    legend,
    daysBlockedStart } = props;
  const headings = ['Su', "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const headingColumns = headings.map(heading => {
    return (
      <div className='schedulerMatrixHeading'>
        {heading}
      </div>
    )
  });

  const rows = [];
  const firstDateInMatrix = getSchedulerFirstDayInView(date);
  let cellDate = new Date(firstDateInMatrix.getTime());
  const numWeeksDisplayed = 6;

  let index = 0;
  let disableForward = false;
  let matrixValues = {};
  let rangeHasEnded = false;
  for (let i = 0; i < numWeeksDisplayed; i++) {
    for (let j = 0; j < 7; j++) {
      let selected = false;
      let disabled = false;
      let isEndOfAvailableRange = false;

      if (minimumDate) {
        if (minimumDate >= cellDate.getTime()) {
          disabled = true;
        }
      }

      if (selectedDates) {
        selected = selectedDates.indexOf(cellDate.getTime()) > -1;
      }

      if (selectionDateRangeStart && !selectionDateRangeEnd) {
        selected = selectionDateRangeStart.getTime() === cellDate.getTime();
      } else if (selectionDateRangeStart && selectionDateRangeEnd) {
        selected = cellDate.getTime() >= selectionDateRangeStart && cellDate.getTime() <= selectionDateRangeEnd;
      }

      if (selectionDateRangeStart) {
        const dayDiff = dayDifference(selectionDateRangeStart, cellDate) + 1;
        if (dayRangesAllowed && dayDiff != 1) {
          disabled = dayRangesAllowed.indexOf(dayDiff) === -1;
          // if (!rangeHasEnded && (selectionDateRangeStart.getTime() + (1000 * 60 * 60 * 24)) < cellDate.getTime()) {
          //   debugger;
          //   isEndOfAvailableRange = true;
          //   rangeHasEnded = true;
          // }
        }
      }

      if (daysBlockedStart) {
        if (j == 0 && daysBlockedStart.indexOf("Sunday") > -1) {
          disabled = true;
        } else if (j == 1 && daysBlockedStart.indexOf("Monday") > -1) {
          disabled = true;
        } else if (j == 2 && daysBlockedStart.indexOf("Tuesday") > -1) {
          disabled = true;
        } else if (j == 3 && daysBlockedStart.indexOf("Wednesday") > -1) {
          disabled = true;
        } else if (j == 4 && daysBlockedStart.indexOf("Thursday") > -1) {
          disabled = true;
        } else if (j == 5 && daysBlockedStart.indexOf("Friday") > -1) {
          disabled = true;
        } else if (j == 6 && daysBlockedStart.indexOf("Saturday") > -1) {
          disabled = true;
        }
      }

      if (blockedDates) {
        if (blockedDates.indexOf(cellDate.getTime()) > -1) {
          disabled = true;
        }
      }

      if (disableForward) {
        disabled = true;
      }

      let dayAvailability = {};
      if (availability) {
        let daystamp = generateDaystamp(cellDate);
        if (availability[daystamp]) {
          dayAvailability = availability[daystamp];
        }
      }

      if (dayAvailability && dayAvailability.count != null) {
        if (dayAvailability.count > 0) {

        } else if (dayAvailability.count <= 0) {
          disabled = true;
          if (!disableForward && selectionDateRangeStart && cellDate.getTime() > selectionDateRangeStart) {
            isEndOfAvailableRange = true;
            disableForward = true;
          }
        }
      }

      if (!matrixValues[i]) {
        matrixValues[i] = {};
      }

      matrixValues[i][j] = {
        selected,
        disabled,
        key: cellDate.getTime(),
        col: j,
        index: index,
        availability: dayAvailability,
        date: cellDate,
        isEndOfAvailableRange: isEndOfAvailableRange,
        offMonth: cellDate.getMonth() !== date.getMonth()
      }

      cellDate = addDays(cellDate, 1);
      index++;
    }
  }

  for (let i = 0; i < numWeeksDisplayed; i++) {
    let cells = [];
    for (let j = 0; j < 7; j++) {
      let data = matrixValues[i][j];
      let next;
      if (i < numWeeksDisplayed - 1) {
        if (j === 6) {
          next = matrixValues[i + 1][0];
        } else {
          next = matrixValues[i][j + 1];
        }
      }

      let disabled = data.disabled;
      // if (next && next.isEndOfAvailableRange) {
      //   disabled = false;
      // }
      cells.push(<SchedulerMatrixCell
        motion={motion}
        selected={data.selected}
        disabled={disabled}
        onSelectDay={onSelectDay}
        onHoverDay={onHoverDay}
        showEndDateNote={showEndDateNote}
        showAvailabilityCounts={showAvailabilityCounts}
        dayRangesAllowed={dayRangesAllowed}
        selectionDateRangeStart={selectionDateRangeStart}
        selectionDateRangeEnd={selectionDateRangeEnd}
        key={data.key}
        col={data.col}
        index={data.index}
        availability={data.availability}
        date={data.date}
        hoverDate={hoverDate}
        offMonth={data.offMonth} />)
    }
    rows.push(
      <div className='schedulerMatrixRow'>
        {cells}
      </div>
    )
  }

  // Visible range of dates
  onSetViewRange(firstDateInMatrix, cellDate);

  let timeframeRow;
  if (allowSelectTimeframes) {
    let timeStartElem;
    let timeEndElem;
    let hasStartTime = false;
    let hasEndTime = false;
    if (selectionDateRangeStart) {
      let displayedText = "Not Picked";
      if (timeframeStart) {
        let minTime = selectionDateRangeStart.getTime();
        displayedText = new Date(minTime + timeframeStart).toLocaleTimeString("en-us", { hour: '2-digit', minute: '2-digit' });
        displayedText = (displayedText.startsWith("0") ? displayedText.substring(1, displayedText.length) : displayedText);
        hasStartTime = true;
      }

      let headerText = selectionDateRangeEnd && selectionDateRangeEnd.getTime() !== selectionDateRangeStart.getTime() ? "Scheduled Start Time" : "Scheduled Time";
      if (schedulerTimeframeMatch === 'match') {
        headerText = "Scheduled Start and End Time"
      }

      timeStartElem = <div onClick={onEditTimeframe.bind(null, "start")} className='matrixTimeframeBlock'>
        <div className='matrixTimeframeBlockTitle'>
          {headerText}
        </div>
        <div className={`matrixTimeframeBlockTime ${hasStartTime ? "timeframePicked" : ""}`}>
          <i className='fa fa-clock'></i>
          {displayedText}
        </div>
      </div>
    }

    if (schedulerTimeframeMatch !== "match" && ((allowSingleDay && selectionDateRangeStart != null) || (selectionDateRangeStart && selectionDateRangeEnd && selectionDateRangeEnd.getTime() !== selectionDateRangeStart.getTime()))) {
      let displayedText = "Not Picked";
      if (timeframeEnd) {
        let minTime = selectionDateRangeStart.getTime();
        displayedText = new Date(minTime + timeframeEnd).toLocaleTimeString("en-us", { hour: '2-digit', minute: '2-digit' });
        displayedText = (displayedText.startsWith("0") ? displayedText.substring(1, displayedText.length) : displayedText);
        hasEndTime = true;
      }

      if (endTimeRequirement === null ||
        endTimeRequirement === "always_ask" ||
        endTimeRequirement === "ask_not_same_day") {
        let skip = false;
        if (endTimeRequirement === "ask_not_same_day") {
          if (allowSingleDay && selectionDateRangeStart != null && selectionDateRangeEnd == null) {
            skip = true;
          } else if (selectionDateRangeStart != null && selectionDateRangeEnd != null && selectionDateRangeStart.getTime() === selectionDateRangeEnd.getTime()) {
            skip = true;
          }
        }

        if (!skip) {
          timeEndElem = <div style={{ marginLeft: 5 }} onClick={onEditTimeframe.bind(null, "end")} className={`matrixTimeframeBlock ${timeframeStart != null ? '' : 'blockDisabled'}`}>
            <div className='matrixTimeframeBlockTitle'>
              Scheduled End Time
            </div>
            <div className={`matrixTimeframeBlockTime  ${hasEndTime ? "timeframePicked" : ""}`}>
              <i className='fa fa-clock'></i>
              {displayedText}
            </div>
          </div>
        }
      }

    }


    timeframeRow = <div className='schedulerMatrixTimeframes'>
      {timeStartElem}
      {timeEndElem}
    </div>
  }

  return (
    <div className='schedulerMatrixContainer'>
      <div className='schedulerMatrixHeader'>
        {headingColumns}
      </div>
      <div className='schedulerMatrixRows'>
        {rows}
      </div>
      {timeframeRow}
      <SchedulerLegend legend={legend} />
    </div>
  )
}

function SchedulerLegend(props) {
  const { legend } = props;
  if (legend) {
    let legendElems = [];
    legend.forEach(legendItem => {
      legendElems.push(<div className="schedulerLegendItem">
        <div style={{ background: legendItem.color }} className="schedulerLegendColor"></div>
        <div className="schedulerLegendLabel">{legendItem.label}</div>
      </div>)
    });

    return <div className="schedulerLegend">
      {legendElems}
    </div>
  } else {
    return null;
  }
}

function SchedulerTimeSelector(props) {
  let { selectionDateRangeStart,
    selectionDateRangeEnd,
    timeframeInterval,
    timeframeStart,
    timeframeEnd,
    onSelectTime,
    selectedTimeframeStart,
    selectedTimeframeEnd,
    onCancel,
    schedulerStartTimeOffset,
    timeframeSelectorProperties } = props;

  let header;
  let times = [];
  if (selectionDateRangeStart && timeframeSelectorProperties && timeframeSelectorProperties.timeframe === 'start') {
    let titleText;
    if (selectionDateRangeStart && (!selectionDateRangeEnd || (selectionDateRangeStart.getTime() === selectionDateRangeEnd.getTime()))) {
      titleText = "Select a Time"
    } else {
      titleText = "Select a Start Time"
    }

    header = <div className="timeframePickerHeader">
      <div className="timeframePickerHeaderTitle">
        {titleText}
      </div>
      <div className="timeframePickerHeaderSubtitle">
        {selectionDateRangeStart.toLocaleDateString()}
      </div>
    </div>

    if (timeframeInterval != null && timeframeStart != null && timeframeEnd != null) {
      let minTime = selectionDateRangeStart.getTime();
      for (let time = timeframeStart; time <= timeframeEnd; time += timeframeInterval) {
        let disabled = false;
        if ((minTime + time) < new Date().getTime() + schedulerStartTimeOffset) {
          disabled = true;
        }
        let displayedTime = new Date(minTime + time).toLocaleTimeString("en-us", { hour: '2-digit', minute: '2-digit' });
        if (displayedTime.startsWith("0")) {
          displayedTime = displayedTime.substring(1, displayedTime.length);
        }
        times.push(<div onClick={onSelectTime.bind(null, time, 'start')} className={`timeframePickerOption  ${disabled ? 'timeframeOptionDisabled' : ''} ${time === selectedTimeframeStart ? 'timeframeSelected' : ''}`}>{displayedTime}</div>)
      }
    }
  }



  if (selectionDateRangeEnd && timeframeSelectorProperties && timeframeSelectorProperties.timeframe === 'end') {
    let titleText;
    titleText = "Select an End Time"

    header = <div className="timeframePickerHeader">
      <div className="timeframePickerHeaderTitle">
        {titleText}
      </div>
      <div className="timeframePickerHeaderSubtitle">
        {selectionDateRangeEnd.toLocaleDateString()}
      </div>
    </div>

    // (() => {
    //   let string = "3:45:53 PM";
    //   let tokens = string.split(":");
    //   let am_pm = tokens[2].split(" ")[1].toLowerCase();
    //   let hours = parseInt(tokens[0]);
    //   let mins = parseInt(tokens[1]);
    //   let seconds = parseInt(tokens[2].split(" ")[0]);
    //   if (am_pm === 'pm') {
    //     hours += 12
    //   }

    //   console.log((hours*60*60+mins*60+seconds)*1000);
    // })()

    // function timeToMillis(timeString) {
    //   let tokens = timeString.split(":");
    //   let am_pm = tokens[2].split(" ")[1].toLowerCase();
    //   let hours = parseInt(tokens[0]);
    //   let mins = parseInt(tokens[1]);
    //   let seconds = parseInt(tokens[2].split(" ")[0]);
    //   if (hours === 12) {
    //     hours = 0;
    //   }
    //   if (am_pm === 'pm') {
    //     hours += 12
    //   }

    //   return (hours*60*60+mins*60+seconds)*1000;
    // }

    if (timeframeInterval != null && timeframeStart != null && timeframeEnd != null) {
      let minTime = selectionDateRangeEnd.getTime();
      for (let time = timeframeStart; time <= timeframeEnd; time += timeframeInterval) {
        let disabled = false;
        let displayedTime = new Date(minTime + time).toLocaleTimeString("en-us", { hour: '2-digit', minute: '2-digit' });
        if (selectionDateRangeStart.getTime() === selectionDateRangeEnd.getTime()) {
          if (minTime + time <= selectionDateRangeStart.getTime() + selectedTimeframeStart) {
            disabled = true;
          }
        }
        times.push(<div onClick={onSelectTime.bind(null, time, 'end')} className={`timeframePickerOption ${disabled ? 'timeframeOptionDisabled' : ''} ${time === selectedTimeframeEnd ? 'timeframeSelected' : ''}`}>{displayedTime}</div>)
      }
    }
  }

  return <div className="timeframePicker">
    {header}
    <div className="timeframePickerScrollableContainer">
      <div className="timeframePickerTimeOptions">
        {times}
      </div>
    </div>
    <div className="timeframePickerFooter">
      <div onClick={props.onCancel} className="timeframePickerCancelButton">
        Go Back
      </div>
    </div>
  </div>
}

function Scheduler(props) {
  let t = new Date();
  const { dayRangesAllowed,
    showAvailabilityCounts,
    onViewedTimerangeChange,
    onDateRangeChange,
    onTimeframeChange,
    onDateSelected,
    minimumDate,
    maximumDate,
    legend,
    daysAllowed,
    showEndDateNote,
    endTimeRequirement,
    allowSelectTimeframes,
    allowSingleDay,
    timeframeInterval,
    timeframeStart,
    timeframeEnd,
    blockedDates,
    schedulerTimeframeMatch,
    schedulerStartTimeOffset,
    daysBlockedStart,
    daySelectMode,
    availability } = props;

  let initialDateStart = props.selectionDateRangeStart;
  let initialDateEnd = props.selectionDateRangeEnd;
  if (typeof (initialDateStart) === 'number') {
    initialDateStart = new Date(initialDateStart);
  }
  if (typeof (initialDateEnd) === 'number') {
    initialDateEnd = new Date(initialDateEnd);
  }
  const [initialDate, setInitialDate] = useState(props.initialDate ? props.initialDate : new Date(t.getFullYear(), t.getMonth(), 1));
  const [selectionDateRangeStart, setSelectionDateRangeStart] = useState(initialDateStart);
  const [selectionDateRangeEnd, setSelectionDateRangeEnd] = useState(initialDateEnd);
  const [selectionTimeframeStart, setSelectionTimeframeStart] = useState(timeframeStart);
  const [selectionTimeframeEnd, setSelectionTimeframeEnd] = useState(timeframeEnd);
  const [selectedDates, setSelectedDates] = useState(props.selectedDates ? props.selectedDates : []);
  const [hoverDate, setHoverDate] = useState(null);
  const [motion, setMotion] = useState('left');
  const [viewRange, setViewRange] = useState({});
  const [timeframeSelectorProperties, setTimeframeSelectorProperties] = useState({
    visible: false,
    timeframe: 'start'
  });

  useEffect(() => {
    if (props.selectionDateRangeStart) {
      setSelectionDateRangeStart(new Date(props.selectionDateRangeStart));
    } else {
      setSelectionDateRangeStart(null);
    }
    if (props.selectionDateRangeEnd) {
      setSelectionDateRangeEnd(new Date(props.selectionDateRangeEnd));
    } else {
      setSelectionDateRangeEnd(null)
    }
    if (props.selectionTimeframeStart) {
      setSelectionTimeframeStart(new Date(props.selectionTimeframeStart));
    } else {
      setSelectionTimeframeStart(null)
    }
    if (props.selectionTimeframeEnd) {
      setSelectionTimeframeEnd(new Date(props.selectionTimeframeEnd));
    } else {
      setSelectionTimeframeEnd(null)
    }
  }, [props.selectionDateRangeStart, props.selectionDateRangeEnd, props.selectionTimeframeStart, props.selectionTimeframeEnd])

  const onSetViewRange = (start, end) => {
    if (!viewRange.start || !viewRange.end) {
      setViewRange({
        start: start,
        end: end
      })
      if (onViewedTimerangeChange) {
        onViewedTimerangeChange(start, end)
      }
    } else if (viewRange.start.getTime() !== start.getTime() || viewRange.end.getTime() !== end.getTime()) {
      setViewRange({
        start: start,
        end: end
      })
      if (onViewedTimerangeChange) {
        onViewedTimerangeChange(start, end)
      }
    }
  }

  const incrementMonth = () => {
    setInitialDate(addMonths(initialDate, 1));
    setMotion('right');
  }

  const decrementMonth = () => {
    setInitialDate(addMonths(initialDate, -1));
    setMotion('left');
  }

  const handleSelectDay = (date) => {

    if (date === null) {
      setSelectionDateRangeStart(null);
      setSelectionDateRangeEnd(null);
      setSelectionTimeframeEnd(null);
      setSelectionTimeframeStart(null);
      if (onDateRangeChange) {
        onDateRangeChange({
          dateRangeStart: null,
          dateRangeEnd: null,
          dayRangeCount: -1
        })
      }

      if (onTimeframeChange) {
        onTimeframeChange({
          timeframeStart: null,
          timeframeEnd: null,
        })
      }

      return;
    }

    if (daySelectMode) {
      let dates = [...selectedDates];
      if (daySelectMode === 'single') {
        dates = [date.getTime()];
      } else {
        if (dates.indexOf(date.getTime()) > -1) {
          dates.splice(dates.indexOf(date.getTime()), 1);
        } else {
          dates.push(date.getTime());
        }
      }

      onDateSelected(date, dates);
      setSelectedDates(dates);
      return;
    }

    if (selectionDateRangeStart && selectionDateRangeStart.getTime() === date.getTime()) {
      setSelectionDateRangeStart(null);
      setSelectionDateRangeEnd(null);
      setSelectionTimeframeEnd(null);
      if (onDateRangeChange) {
        onDateRangeChange({
          dateRangeStart: null,
          dateRangeEnd: null,
          dayRangeCount: -1
        })
      }

      if (onTimeframeChange) {
        onTimeframeChange({
          timeframeStart: selectionTimeframeStart,
          timeframeEnd: null,
        })
      }
    } else {
      if (selectionDateRangeStart) {
        if (date.getTime() > selectionDateRangeStart.getTime()) {
          setSelectionDateRangeEnd(date);
          if (onDateRangeChange) {
            onDateRangeChange({
              dateRangeStart: selectionDateRangeStart,
              dateRangeEnd: date,
              dayRangeCount: dayDifference(selectionDateRangeStart, date) + 1
            })
          }
        } else {
          setSelectionDateRangeEnd(selectionDateRangeStart);
          setSelectionDateRangeStart(date);
          if (onDateRangeChange) {
            onDateRangeChange({
              dateRangeStart: date,
              dateRangeEnd: selectionDateRangeStart,
              dayRangeCount: dayDifference(date, selectionDateRangeStart) + 1
            })
          }
        }
      } else {
        setSelectionDateRangeStart(date);
        if (onDateRangeChange) {
          if (allowSingleDay) {
            onDateRangeChange({
              dateRangeStart: date,
              dateRangeEnd: date,
              dayRangeCount: 1
            })
          } else {
            onDateRangeChange({
              dateRangeStart: date,
              dateRangeEnd: null,
              dayRangeCount: -1
            })
          }
        }
      }
    }
  }

  const onSelectTime = (time, timeframe) => {
    if (timeframe === 'start') {
      let start = time;
      let end = selectionTimeframeEnd;
      setSelectionTimeframeStart(time);
      if (selectionTimeframeEnd != null) {
        if (selectionTimeframeEnd <= time) {
          setSelectionTimeframeEnd(null);
          end = null;
        }
      }

      if (onTimeframeChange) {
        onTimeframeChange({
          timeframeStart: start,
          timeframeEnd: end,
        })
      }
    } else if (timeframe === 'end') {
      setSelectionTimeframeEnd(time);
      if (onTimeframeChange) {
        onTimeframeChange({
          timeframeStart: selectionTimeframeStart,
          timeframeEnd: time,
        })
      }
    }

    setTimeframeSelectorProperties({
      visible: false,
    });
  }

  const onEditTimeframe = (timeframe) => {
    setTimeframeSelectorProperties({
      visible: true,
      timeframe: timeframe
    });
  }

  const onCancelTime = () => {
    setTimeframeSelectorProperties({
      visible: false,
      timeframe: 'start'
    });
  }

  const handleHoverDay = (date, hovered) => {
    if (!hovered) {
      setHoverDate(null);
    } else {
      setHoverDate(date);
    }
  }

  let monthSchedulerStyle = {};
  let timeSelectorStyle = {};

  if (timeframeSelectorProperties.visible) {
    monthSchedulerStyle.transform = "scale3d(1.1,1.1,1.0)";
    monthSchedulerStyle.opacity = 0.0;
    // timeSelectorStyle.transform = "scale3d(1.0,1.0,1.0)";
    timeSelectorStyle.opacity = 1.0;
    timeSelectorStyle.pointerEvents = "all"
  } else {
    // monthSchedulerStyle.transform = "scale3d(1.0,1.0,1.0)";
    monthSchedulerStyle.opacity = 1.0;
    timeSelectorStyle.transform = "scale3d(0.9,0.9,1.0)";
    timeSelectorStyle.opacity = 0.0;
    timeSelectorStyle.pointerEvents = "none"
  }

  return (
    <div className='schedulerContainer'>
      <div style={monthSchedulerStyle} className='monthNavigatorContainer'>
        <SchedulerMonthNavigator key={initialDate.getMonth()} motion={motion} onIncrementMonth={incrementMonth} onDecrementMonth={decrementMonth} date={initialDate} />
        <SchedulerMatrix
          {...props}
          selectedDates={selectedDates}
          blockedDates={blockedDates}
          minimumDate={minimumDate}
          selectionDateRangeStart={selectionDateRangeStart}
          selectionDateRangeEnd={selectionDateRangeEnd}
          allowSelectTimeframes={allowSelectTimeframes}
          showEndDateNote={showEndDateNote}
          timeframeInterval={timeframeInterval}
          timeframeStart={selectionTimeframeStart}
          timeframeEnd={selectionTimeframeEnd}
          timeframeSelectorProperties={timeframeSelectorProperties}
          onEditTimeframe={onEditTimeframe}
          onSelectDay={handleSelectDay}
          onHoverDay={handleHoverDay}
          endTimeRequirement={endTimeRequirement}
          motion={motion}
          hoverDate={hoverDate}
          schedulerTimeframeMatch={schedulerTimeframeMatch}
          showAvailabilityCounts={showAvailabilityCounts}
          availability={availability}
          daysBlockedStart={daysBlockedStart}
          onSetViewRange={onSetViewRange}
          allowSingleDay={allowSingleDay}
          date={initialDate} />
      </div>
      {props.showTimePicker !== false && <div style={timeSelectorStyle} className='timeSelectorContainer'>
        <SchedulerTimeSelector
          selectionDateRangeStart={selectionDateRangeStart}
          selectionDateRangeEnd={selectionDateRangeEnd}
          timeframeInterval={timeframeInterval}
          timeframeStart={timeframeStart}
          selectedTimeframeStart={selectionTimeframeStart}
          selectedTimeframeEnd={selectionTimeframeEnd}
          timeframeEnd={timeframeEnd}
          onSelectTime={onSelectTime}
          onCancel={onCancelTime}
          schedulerTimeframeMatch={schedulerTimeframeMatch}
          schedulerStartTimeOffset={schedulerStartTimeOffset}
          timeframeSelectorProperties={timeframeSelectorProperties} />
      </div>}
    </div>
  );
}

Scheduler.propTypes = {};

export default Scheduler;
